import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const STATUS_META = {
  awaiting_dispatch: { label: "Awaiting Dispatch", color: "#5B21B6", bg: "#F5F0FE", chipBg: "#F2EEFE", chipText: "#5B21B6" },
  awaiting_parts:    { label: "Awaiting Parts",    color: "#5B21B6", bg: "#F5F0FE", chipBg: "#F2EEFE", chipText: "#5B21B6" },
  scheduled:         { label: "Scheduled",         color: "#94A3B8", bg: "#F1F5F9", chipBg: "#EEF1F5", chipText: "#5B6472" },
  on_site:           { label: "On Site",           color: "#B45309", bg: "#FEF3C7", chipBg: "#FFF6E5", chipText: "#96650A" },
  on_hold:           { label: "On Hold",           color: "#5B21B6", bg: "#F5F0FE", chipBg: "#F2EEFE", chipText: "#5B21B6" },
  equipment_down:    { label: "Equipment Down",    color: "#B91C1C", bg: "#FEE2E2", chipBg: "#FDECEC", chipText: "#B42318" },
  tech_complete:     { label: "Pending Review",     color: "#0E7490", bg: "#E0F2FE", chipBg: "#E3F2FB", chipText: "#0B6080" },
  complete:          { label: "Complete",          color: "#15803D", bg: "#DCFCE7", chipBg: "#E9F7EE", chipText: "#136B36" },
};

export const PRIORITY_META = {
  equipment_down: { label: "Equipment Down", color: "#B91C1C" },
  standard:       { label: "Standard",       color: "#5F6B7A" },
  low:            { label: "Low",            color: "#94A3B8" },
};

export function fmtTicket(t) { return t || ""; }

export function fmtTimeAST(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", {
      timeZone: "America/Barbados",
      day: "2-digit", month: "short",
      hour: "2-digit", minute: "2-digit", hour12: false,
    });
  } catch { return iso; }
}

export function msToCountdown(ms) {
  const sign = ms < 0 ? "-" : "";
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3600000);
  const m = Math.floor((abs % 3600000) / 60000);
  return `${sign}${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

/** Return true if `whenIso` falls inside at least one service window for area. */
export function inServiceWindow(area, whenIso) {
  if (!area?.service_windows?.length || !whenIso) return true;
  const d = new Date(whenIso);
  // Day-of-week in Barbados (Mon=0..Sun=6)
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "America/Barbados",
    weekday: "short", hour: "2-digit", minute: "2-digit",
    month: "2-digit", day: "2-digit", hour12: false,
  }).formatToParts(d);
  const get = k => parts.find(p => p.type === k)?.value;
  const dowMap = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
  const dow = dowMap[get("weekday")];
  const hh = parseInt(get("hour"), 10);
  const mm = parseInt(get("minute"), 10);
  const mins = hh * 60 + mm;
  const mo = get("month");
  const dd = get("day");
  const mmdd = `${mo}-${dd}`;
  const inSeason = (ss, se) => {
    if (!ss || !se) return true;
    if (ss <= se) return mmdd >= ss && mmdd <= se;
    return mmdd >= ss || mmdd <= se; // wraps year end (e.g., Dec->Apr)
  };
  for (const w of area.service_windows) {
    if (!w.days.includes(dow)) continue;
    if (!inSeason(w.season_start, w.season_end)) continue;
    const [sh, sm] = w.start.split(":").map(Number);
    const [eh, em] = w.end.split(":").map(Number);
    const startM = sh * 60 + sm;
    const endM = eh * 60 + em;
    if (mins >= startM && mins <= endM) return true;
  }
  return false;
}
